import templateUrl from './changePhasePopup.html';
import controller from './changePhasePopup.controller';
import './changePhasePopup.scss';

const changePhasePopupComponent = {
	bindings: {
		componentReady: '&'
	},
	templateUrl,
	controller
};

export default changePhasePopupComponent;
